import { render, staticRenderFns } from "./MainCont.vue?vue&type=template&id=ca71496a&scoped=true&"
import script from "./MainCont.vue?vue&type=script&lang=js&"
export * from "./MainCont.vue?vue&type=script&lang=js&"
import style0 from "./MainCont.vue?vue&type=style&index=0&id=ca71496a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca71496a",
  null
  
)

export default component.exports